module.exports = __webpack_public_path__ + "static/media/bar-vertical-icon.53e3a098.svg";